var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickGreenIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__tick",
    width: 16.484,
    height: 16.484,
    viewBox: "0 0 16.484 16.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .tg-prefix{fill:#6b0}.tick-green-prefix{fill:#fff}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_677",
    d: "M8.242 0a8.242 8.242 0 1 0 8.242 8.242A8.271 8.271 0 0 0 8.242 0z",
    className: "tg-prefix",
    "data-name": "Path 677"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_678",
    d: "M264.242 8.242A8.271 8.271 0 0 1 256 16.484V0a8.271 8.271 0 0 1 8.242 8.242z",
    className: "tg-prefix",
    "data-name": "Path 678",
    transform: "translate(-247.758)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_679",
    d: "M109.425 171.562l-5.66 5.66-4.065-4.057 1.372-1.372 2.695 2.7.966-.966 3.332-3.332z",
    className: "tick-green-prefix",
    "data-name": "Path 679",
    transform: "translate(-96.489 -164.72)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_680",
    d: "M260.694 171.562L256 176.256v-2.724l3.332-3.332z",
    className: "tick-green-prefix",
    "data-name": "Path 680",
    transform: "translate(-247.758 -164.72)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreenIcon);
export default __webpack_public_path__ + "static/media/TickGreenIcon.3ea1b9d28eee597a469aa9d7dcb878a5.svg";
export { ForwardRef as ReactComponent };